import React from 'react';
import { Subtitle } from '../../Common/Subtitle';
import { AddOnItem, AddOnPrice, AddOnType } from '~/types/models/addon';
import { CustomDomainAddOnCard } from './CustomDomainAddOnCard';
import { UserAddOnCard } from './UserAddOnCard';
import { useFeatures } from '~/react-hooks/use-features';
import { BillingCycle, Service } from '~/types/models';
import { RollupLimitAddOnCard } from './RollUpLimitAddOn/RollUpLimitAddOnCard';

export interface AvailableAddOnsProps {
  service?: Service;
  addOnPrices?: AddOnPrice[];
  addOns?: AddOnItem[];
  billingCycle?: BillingCycle;
}

export function AvailableAddOns({
  addOnPrices,
  addOns,
  service,
  billingCycle,
}: AvailableAddOnsProps) {
  const {
    canPurchaseUserAddOn,
    canPurchaseDomainAddOn,
    canPurchaseRollUpLimitAddOn,
  } = useFeatures();
  const customDomainAddOnPrice = addOnPrices?.find(
    (item) => item.type === AddOnType.CustomDomain
  );

  const customDomainAddOn = addOns?.find(
    (item) => item.type === AddOnType.CustomDomain
  );

  const userAddOnPrice = addOnPrices?.find(
    (item) => item.type === AddOnType.TeamMember
  );

  const userAddOn = addOns?.find((item) => item.type === AddOnType.TeamMember);

  const rollupLimitAddOnPrice = addOnPrices?.find(
    (item) => item.type === AddOnType.LimitGreetRollUp
  );

  const rollupLimitAddOn = addOns?.find(
    (item) => item.type === AddOnType.LimitGreetRollUp
  );

  if (
    !canPurchaseUserAddOn &&
    !canPurchaseDomainAddOn &&
    !canPurchaseRollUpLimitAddOn
  )
    return <></>;

  return (
    <>
      <Subtitle label='My add-ons' />
      <div className='flex flex-col lg:flex-row gap-x-6 gap-y-4 w-full'>
        {canPurchaseRollUpLimitAddOn && service !== Service.Testimonials && (
          <RollupLimitAddOnCard
            price={rollupLimitAddOnPrice}
            details={rollupLimitAddOn}
            billingCycle={billingCycle}
          />
        )}
        {canPurchaseDomainAddOn && (
          <CustomDomainAddOnCard
            price={customDomainAddOnPrice}
            details={customDomainAddOn}
            service={service}
            billingCycle={billingCycle}
          />
        )}
        {canPurchaseUserAddOn && (
          <UserAddOnCard
            price={userAddOnPrice}
            details={userAddOn}
            service={service}
          />
        )}
      </div>
    </>
  );
}
